const action = "USER_GETUSER";
export const REQUEST = action+'_REQUEST';
export const RESPONSE = action+'_RESPONSE';
export const FAILURE = action+'_FAILURE';

export const fetchRequest = () => ({
  type: REQUEST,
});

export const fetchSuccess = (response) => ({
  type: RESPONSE,
  payload: response
});

export const fetchFailure = (error) => ({
  type: FAILURE,
  payload: error
});
